import { ReferentielViolationsDto } from 'lib_api/lib/api/gen';

import { ValidateFunction } from 'components/BaseForm/types';

interface ViolationDto {
  message: string;
}

export function useValidateReferentielForm<
  FormValueT,
  FormFieldT,
  ViolationDtoT extends ViolationDto,
>(
  callApi: (
    field: FormFieldT,
    values: FormValueT,
  ) => Promise<ReferentielViolationsDto>,
  violationMapper: (violation: ReferentielViolationsDto) => ViolationDtoT[],
): ValidateFunction<FormValueT, FormFieldT> {
  const validate = async (field: FormFieldT, values: FormValueT) => {
    const response = await callApi(field, values);

    const violations = violationMapper(response);

    return violations.length === 0
      ? Promise.resolve()
      : Promise.reject(violations[0].message);
  };

  return { validate };
}
